
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/similar-products",
      function () {
        return require("private-next-pages/similar-products/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/similar-products"])
      });
    }
  